import React, { useEffect, useState } from 'react';
import EdgeOrREST from '../EdgeOrREST';
import PhotometricAutocomplete from '../photometricManager/photometric-autocomplete.component';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    Card,
    Divider,
    CardContent,
    makeStyles,
    Grid,
    Button,
    Typography,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    Tooltip,
    DialogTitle,
    TextField
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Notification from '../components/shared/notification.component';
import { useDispatch, useSelector } from 'react-redux';
import user from '../store/actions/user';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(3),
        },
    },
    formControl: {
        margin: theme.spacing(3),
    },
    margin: {
        margin: '0px',
    },
    submit: {
        margin: theme.spacing(1, 0, 2),
    },
    container: {
        maxHeight: '40vh',
        minHeight: '40vh',
    }
}));


export default function AutpmatePlan(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const [savedConfigs, setSavedConfigs] = useState([]);
    const [selectedConfig, setSelectedConfig] = useState([]);
    const [attributes, setAttributes] = useState({
        groupIds: [],
        error: ""
    });
    const [groups, setGroups] = useState([]);
    const [snack, setSnack] = useState({
        open: false
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedGrids, setSelectedGrids] = useState([]);
    const [selectedGrid, setSelectedGrid] = useState("");

    useEffect(() => {
        console.log("selectedGrid", selectedGrid);
    }, [selectedGrid]);

    const handleClose = () => {
        setSnack({
            ...snack,
            open: false
        });
    };

    useEffect(() => {
        EdgeOrREST(null, 'GET_ALL_LOWEST_CHILDREN_FOLDER', onGetGroups, props);
        EdgeOrREST(null, 'GET_ALL_PLAN_SESSION', onGetAllPlanSessionsDescription, null);
    }, []);

    const onGetAllPlanSessionsDescription = (response) => {
        console.log("onGetAllPlanSessionsDescription", response);
        if (response && response.data) {
            setSavedConfigs(response.data);
        } else if (response && response.status === "204") {
            setSavedConfigs([]);
        } else {
            setSnack({
                open: true,
                message: "Get configurations failed.",
                severity: 'warning'
            });
        }
    };

    const onGetGroups = (response) => {
        if (response && response.data) {
            setGroups(response.data);
            dispatch(user.UpdateUserCfg({
                groups: response.data,
                refreshJobs: true
            }));
        }
    };

    const onAutoComplete = (event, value) => {
        console.log("autocomplete");
        if (value) {
            const ids = value.map(element => element.id);
            console.log("ids", ids);
            setAttributes(prevState => ({
                ...prevState,
                groupIds: ids
            }));
        }
    };

    const uploadConfiguration = (grid) => {
        if (selectedConfig.length !== 0) {
            EdgeOrREST(
                null,
                'CREATE_PLAN_AUTOMATE_CALC',
                onUploadConfiguration,
                {
                    selectedConfigId: selectedConfig[0].id,
                    groupIds: attributes.groupIds,
                    mainGrids: grid
                },
                props
            );
        } else {
            setSnack({
                open: true,
                message: "Please select a Plan Configuration.",
                severity: 'error'
            });
        }
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleMainGridSelect = (gridDes) => {
        setSelectedGrid(gridDes);
        setDialogOpen(false);
        uploadConfiguration(gridDes);
        setSnack({
            open: true,
            message: `Selected main grid: ${gridDes}`,
            severity: 'success'
        });
    };

    const onUploadConfiguration = (response) => {
        console.log("GetJobs in Upload");
        if (response && response.status === 200) {
            dispatch(user.UpdateUserCfg({ getJobFlag: !state.user.getJobFlag }));
        } else {
            setSnack({
                open: true,
                message: response.data?.message || "Upload configuration failed.",
                severity: 'error'
            });
        }
    };

    return (
        <Card className={classes.root}>
            <Divider />
            <CardContent>
                <Grid className='automateStep3 automateStep4' container spacing={2} style={{ border: 'solid 0.5px lightgrey', borderRadius: '8px' }}>
                    <Grid item md={12} sm={12} xs={12}>
                        <Typography color="textSecondary" gutterBottom>
                            Select plan configuration and select your photometric group(s).
                            Please note configuration results will be deleted after 3 months.
                        </Typography>
                    </Grid>
                    <Grid item md={12} sm={3} xs={3}>
                        <Typography gutterBottom>
                            Select Configuration:
                        </Typography>
                    </Grid>

                    <Grid item md={12} sm={9} xs={9}>
                        <PhotometricAutocomplete callback={onAutoComplete} groups={groups} />
                    </Grid>

                    <Grid item md={9} sm={9} xs={9} />
                </Grid>

                <Grid container item spacing={2} style={{ marginTop: '20px', border: 'solid 0.5px lightgrey', borderRadius: '8px' }}>
                    <Grid item md={12} sm={12} xs={12}>
                        <Typography color="textSecondary" gutterBottom>
                            Select Configuration: 
                        </Typography>
                    </Grid>
                    <Grid item md={12} sm={8} xs={12} style={{ display: 'flex', justifyContent: 'left' }}>
                        <TextField
                            fullWidth
                            //label="Select Configuration"
                            name="autoTemplateStandard"
                            value={selectedConfig.length > 0 ? JSON.stringify(selectedConfig[0]) : ''}
                            onChange={(e) => {
                                if (e.target.value === '') {
                                    setSelectedConfig([]);
                                } else {
                                    const selected = JSON.parse(e.target.value);
                                    setSelectedConfig([selected]);
                                    console.log("Selected config:", selected);
                                }
                            }}
                            select
                            SelectProps={{ native: true }}
                            variant="outlined"
                        >
                            <option value="" disabled>Select Configuration</option>
                            {savedConfigs.map((option, index) => (
                                <option key={index} value={JSON.stringify(option)}>
                                    {option.description}
                                </option>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item md={9} sm={3} xs={3} />
                    <Grid item md={3} sm={3} xs={3} style={{ display: 'flex', justifyContent: 'right' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => {
                                if (selectedConfig.length === 0) {
                                    setSnack({
                                        open: true,
                                        message: "Please select a Plan Configuration.",
                                        severity: 'error'
                                    });
                                    return;
                                }
                                if (attributes.groupIds.length === 0) {
                                    setSnack({
                                        open: true,
                                        message: "Please select at least one Photometric Group.",
                                        severity: 'error'
                                    });
                                    return;
                                }
                                // Proceed if both validations pass
                                if (typeof selectedConfig[0]?.config === 'string') {
                                    const parsedConfig = JSON.parse(selectedConfig[0].config);
                                    if (parsedConfig.grids) {
                                        setSelectedGrids(parsedConfig.grids.slice(1));
                                    }
                                }
                                handleDialogOpen();
                            }}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>

                <Snackbar
                    open={snack.open}
                    onClose={handleClose}
                    key="snackbar"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    autoHideDuration={7000}
                >
                    <Alert onClose={handleClose} severity={snack.severity}>
                        {snack.message}
                    </Alert>
                </Snackbar>

                <Grid item md={12} sm={12} xs={12}>
                    <Typography color="inherit" gutterBottom>
                        {attributes.error}
                    </Typography>
                    <Notification
                        onClose={handleClose}
                        open={snack.open}
                        severity={snack.severity}
                        message={snack.message}
                    />
                </Grid>

                <Dialog open={dialogOpen} onClose={handleDialogClose}>
                    <DialogTitle>Select Grids in Configuration</DialogTitle>
                    <TableContainer>
                        <Table>
                            <TableBody>
                                {selectedGrids?.map((grid) => (
                                    <TableRow
                                        key={grid.name}
                                        hover
                                        onClick={() => handleMainGridSelect(grid.name)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <TableCell>{grid.name}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Grid container justifyContent="flex-end" style={{ padding: '16px' }}>
                        <Button onClick={handleDialogClose} color="primary">
                            Cancel
                        </Button>
                    </Grid>
                </Dialog>
            </CardContent>
        </Card>
    );
}
